import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

// Error handling
window.addEventListener('error', (e) => {
  // Error logged
});

window.addEventListener('unhandledrejection', (e) => {
  // Unhandled rejection logged
});

try {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }
  
  const root = ReactDOM.createRoot(rootElement);

  // StrictMode disabled to prevent duplicate API calls in development logs
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );

  // Hide loading screen immediately after React mounts
  if (typeof window.hideLoadingScreen === 'function') {
    window.hideLoadingScreen();
  }
} catch (error) {
  // Show error message directly in root
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="padding: 40px; text-align: center; font-family: monospace;">
        <h1 style="color: #a8c97f;">Loading Error</h1>
        <p>Failed to start the application.</p>
        <p>Error: ${error.message}</p>
        <button onclick="window.location.reload()" style="padding: 10px 20px; margin-top: 20px; background: #a8c97f; color: white; border: none; border-radius: 5px; cursor: pointer;">
          Refresh Page
        </button>
      </div>
    `;
  }
}